import React from 'react';
import "./Members.css"
import { Container, Row } from 'react-bootstrap';

const MembersData = [
    //Creative
    // { image: require("../../../assets/AboutPage/Jhansi.png"), name: "Jhansi", teamName: "Creative Design Lead" },
    // { image: require("../../../assets/AboutPage/RajeswariK.png"), name: "Rajeswari", teamName: "Creative Designer" },
    // { image: require("../../../assets/AboutPage/Prasanna.png"), name: "Prasanna", teamName: "Creative Designer" },
    { image: require("../../../assets/AboutPage/Tejaswini.png"), name: "Tejaswini", teamName: "Creative Designer" },
    // { image: require("../../../assets/AboutPage/Sai Gopinadh.png"), name: "Sai Gopinadh", teamName: "Creative Designer" },
    // { image: require("../../../assets/AboutPage/Kumar.png"), name: "Kumar", teamName: "Creative Designer" },

    //Marketing
    // { image: require("../../../assets/AboutPage/Ramesh.png"), name: "Ramesh", teamName: "Marketing Analysis Lead" },
    // { image: require("../../../assets/AboutPage/mounika.png"), name: "Mounika", teamName: "Marketing Analyst" },
    // { image: require("../../../assets/AboutPage/Ganesh.png"), name: "Ganesh", teamName: "Marketing Analyst" },

    //Full Stack Developer
    { image: require("../../../assets/AboutPage/Ajay.png"), name: "Ajay", teamName: "Full Stack Developer" },
    { image: require("../../../assets/AboutPage/Vinod cartoon.png"), name: "Vinod", teamName: "Full Stack Developer" },
    { image: require("../../../assets/AboutPage/Aditya.png"), name: "Aditya", teamName: "Full Stack Developer" },    
    { image: require("../../../assets/AboutPage/Ramesh.png"), name: "Ramesh", teamName: "Full Stack Developer" },
    { image: "", name: "Padmajyothi", teamName: "Full Stack Developer" },
    { image: require("../../../assets/AboutPage/Jagadeesh.png"), name: "Jagadeesh", teamName: "Full Stack Developer" },

    //RPA
    { image: require("../../../assets/AboutPage/Kartheek.png"), name: "Kartheek", teamName: "RPA Developer" },
    { image: require("../../../assets/AboutPage/sairam.png"), name: "Sai Ram", teamName: "RPA Developer" },
    { image: require("../../../assets/AboutPage/saisuchendra.png"), name: "Sai Suchendra", teamName: "RPA Developer" },
    { image: require("../../../assets/AboutPage/chandu.png"), name: "Chandu", teamName: "RPA Developer" },
  

    //UI/UX 
    // { image:"", name: "Manasa", teamName: "Digital Marketer Lead" },

    //Digital Marketer
    // { image: require("../../../assets/AboutPage/Durga Rao.png"), name: "Durga Rao", teamName: "Digital Marketer" },

    //Support Team
    { image: require("../../../assets/AboutPage/Raju.png"), name: "Raju", teamName: "Technical Support Team" },
    { image: require("../../../assets/AboutPage/Rani.png"), name: "Rani", teamName: "Technical Support Team" },
   

    //Housekeeping
    { image: require("../../../assets/AboutPage/Siva Parvathi.png"), name: "Siva Parvathi", teamName: "Front Desk" },
    { image: "", name: "Ammaji", teamName: "Housekeeping" },
    { image: "", name: "Naga Lakshmi", teamName: "Housekeeping" },
    { image: "", name: "Lakshmi", teamName: "Housekeeping" },

    { image: "", name: "", teamName: "s" },
    { image: "", name: "", teamName: "s" },
    { image: "", name: "", teamName: "s" },
]


function Members(props) {


    return (
        <Container className='MembersContainer' fluid >
            <Row className='MembersContainer-Row'>
                {
                    MembersData.map((MemberData) => {
                        if (MemberData.name) {
                            return (
                                <div className='Member' key={MemberData.name}>
                                    <Row className='Member-Row'>
                                        <div style={{ backgroundImage: `url("${MemberData.image}")` }} className='MemberImage'>

                                        </div>
                                    </Row>
                                    <Row className='Member-Row' >
                                        <div>
                                            <h6 className='Member-name'>{MemberData.name}</h6>
                                        </div>
                                        <div className='Member-teamName'>
                                            {MemberData.teamName}
                                        </div>
                                    </Row>
                                </div>

                            )
                        }
                        else {
                            return (
                                <div className='Member' key={MemberData.teamName}>
                                    <Row className='Member-Row'>
                                    </Row>
                                    <Row className='Member-Row' >
                                    </Row>
                                </div>
                            )
                        }
                    })
                }
            </Row>
        </Container>
    );
}

export default Members;